import { Toaster } from "@hulahoop/ui";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { connectDsToasts } from "@/app/connectDsToasts";

export function AppToaster() {
  const { t } = useTranslation();
  useEffect(connectDsToasts, []);
  return <Toaster closeLabel={t("foundation.dismiss")} />;
}
